/** Follow-type badge (§3): legislation scroll-text, person user-round, topic tag, committee landmark, on its --type-*-bg. */
import { Landmark, ScrollText, Tag, UserRound } from "lucide-react";
import type { FollowType } from "../../types";

export const TYPE_ICON = { legislation: ScrollText, person: UserRound, topic: Tag, committee: Landmark } as const;

export function TypeBadge({ type, size = 18 }: { type: FollowType; size?: 16 | 18 }) {
  const Icon = TYPE_ICON[type];
  return <i className="type-badge" data-type={type} style={{ width: size, height: size }} aria-hidden><Icon size={size === 16 ? 10 : 11} /></i>;
}
